import { useState } from 'react';
import SectionReveal from './SectionReveal';
import img1 from '../assets/1.png';
import img2 from '../assets/2.png';
import img3 from '../assets/3.png';
import img4 from '../assets/4.png';
import img5 from '../assets/5.png';
import img6 from '../assets/6.png';

const imageMap = { img1, img2, img3, img4, img5, img6 };

const defaultProjects = [
  { title: 'Քաղաքային կեղտաջրերի մաքրման կայան', category: 'Municipal', image: img1, desc: 'Ժամանակակից ավտոմատացված համակարգ համայնքային կեղտաջրերի լիարժեք մաքրման համար:' },
  { title: 'Արդյունաբերական ջրհեռացման համակարգ', category: 'Industrial', image: img2, desc: 'Բարձր արտադրողականությամբ ֆիլտրման կայան արտադրական ձեռնարկությունների համար:' },
  { title: 'Հյուրանոցային համալիրի մաքրման կայան', category: 'Hotels', image: img3, desc: 'Կոմպակտ և անաղմուկ լուծում բարձրակարգ հյուրանոցների և հանգստյան գոտիների համար:' },
  { title: 'Կրթական համալիրի ջրմուղ-կոյուղի', category: 'Schools', image: img4, desc: 'Անվտանգ և էկոլոգիապես մաքուր տեխնոլոգիաներ դպրոցների և մանկապարտեզների համար:' },
  { title: 'Բնակելի թաղամասի համակարգ', category: 'Residential', image: img5, desc: 'Մոդուլային կայաններ նորակառույց բնակելի համալիրների և թաղամասերի համար:' },
  { title: 'Հասարակական սանհանգույցի մաքրում', category: 'Public Toilets', image: img6, desc: 'Լակոնային և ինքնավար մաքրման լուծումներ հասարակական վայրերի համար:' }
];

export default function ProjectsSection({ t }) {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = t?.projectCategories || [
    { label: 'All', value: 'All' },
    { label: 'Municipal', value: 'Municipal' },
    { label: 'Industrial', value: 'Industrial' },
    { label: 'Hotels', value: 'Hotels' },
    { label: 'Schools', value: 'Schools' },
    { label: 'Residential', value: 'Residential' },
    { label: 'Public Toilets', value: 'Public Toilets' },
  ];

  const projects = (t?.projects || defaultProjects).map(p => ({
    ...p,
    image: imageMap[p.image] || p.image
  }));

  const filteredProjects = activeCategory === 'All'
    ? projects
    : projects.filter(p => p.category === activeCategory);

  return (
    <section id="projects" className="relative bg-white px-3 py-16 md:px-10">
      <div className="mx-auto max-w-7xl space-y-10">

        <SectionReveal>
          <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-4">
              {t?.projectsTitle || 'Նախագծեր'}
            </h2>
            <p className="text-base text-slate-600 leading-relaxed">
              {t?.projectsSubtitle || 'Մեր կողմից իրականացված հաջողված ինժեներական լուծումները'}
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={100}>
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex gap-2 p-3 min-w-max">
              {categories.map((cat, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveCategory(cat.value)}
                  className={`px-4 py-2.5 text-xs font-bold uppercase tracking-wider whitespace-nowrap transition-all ${activeCategory === cat.value
                      ? 'bg-[#0FA4E8] text-white'
                      : 'text-[#0B3B6F] bg-gray-50 hover:bg-gray-100'
                    }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
        </SectionReveal>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filteredProjects.map((project, idx) => (
            <SectionReveal key={project.title + idx} delay={idx * 80}>
              <div className="group p-3 cursor-pointer">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0B3B6F]/0 group-hover:bg-[#0B3B6F]/10 transition-colors" />
                  <span className="absolute top-4 left-4 px-3 py-1 bg-white text-[10px] font-bold uppercase tracking-wider text-[#0B3B6F]">
                    {project.category}
                  </span>
                </div>
                <div className="pt-4 rounded-none">
                  <h3 className="text-base font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors mb-2">
                    {project.title}
                  </h3>
                  <p className="text-sm rounded-none text-slate-500 leading-relaxed line-clamp-2">
                    {project.desc}
                  </p>
                </div>
              </div>
            </SectionReveal>
          ))}
        </div>

      </div>
    </section>
  );
}